// 导入polyfill，确保老旧浏览器兼容性
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom/client';
import i18n from './i18n'; // 🌐 i18n 初始化（必须在 App 之前）
import './index.css';
import './compat.css'; // 导入兼容性样式
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyCompatibilityFixes } from './utils/browserCompat';

// 应用浏览器兼容性修复
const browserCompat = applyCompatibilityFixes();

// 如果是旧浏览器，显示警告信息
if (browserCompat.isOldBrowser) {
  const warningText = i18n.t('browser_compat_warning');
  const closeText = i18n.t('browser_compat_close');
  console.warn(warningText);

  // 添加兼容性警告到页面
  const warningDiv = document.createElement('div');
  warningDiv.style.position = 'fixed';
  warningDiv.style.top = '0';
  warningDiv.style.left = '0';
  warningDiv.style.right = '0';
  warningDiv.style.backgroundColor = '#f8d7da';
  warningDiv.style.color = '#721c24';
  warningDiv.style.padding = '10px';
  warningDiv.style.textAlign = 'center';
  warningDiv.style.zIndex = '9999';
  warningDiv.style.fontSize = '14px';
  warningDiv.innerHTML = `${warningText}<button style="margin-left: 10px; padding: 2px 8px; cursor: pointer;" onclick="this.parentNode.style.display='none'">${closeText}</button>`;

  document.body.appendChild(warningDiv);
}

// 使用兼容的方式创建React根元素
let root;
try {
  // 现代浏览器的方式
  root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (e) {
  // 如果createRoot方法不可用，回退到旧的render方法
  console.warn('使用兼容模式渲染React应用');
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
